import { render, staticRenderFns } from "./DoubleDistributeModal.vue?vue&type=template&id=a62f21d4&scoped=true"
import script from "./DoubleDistributeModal.vue?vue&type=script&lang=js"
export * from "./DoubleDistributeModal.vue?vue&type=script&lang=js"
import style0 from "./DoubleDistributeModal.vue?vue&type=style&index=0&id=a62f21d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62f21d4",
  null
  
)

export default component.exports